const mapManufacturerToClient = (serverManufacturer)=>{
    if (!serverManufacturer || serverManufacturer.__typename !== 'ManufacturerSuccessResponse') {
        return undefined;
    }
    const { address , name  } = serverManufacturer.result;
    const { city , country , electronic , line1 , line2 , line3 , zipCode  } = address !== null && address !== void 0 ? address : {};
    // Check if at least one field is present
    if (name || electronic || Boolean(city && country && (line1 || line2 || line3) && zipCode)) {
        return {
            name: name !== null && name !== void 0 ? name : undefined,
            city: city !== null && city !== void 0 ? city : undefined,
            country: country !== null && country !== void 0 ? country : undefined,
            electronicAddress: electronic !== null && electronic !== void 0 ? electronic : undefined,
            line1: line1 !== null && line1 !== void 0 ? line1 : undefined,
            line2: line2 !== null && line2 !== void 0 ? line2 : undefined,
            line3: line3 !== null && line3 !== void 0 ? line3 : undefined,
            zipCode: zipCode !== null && zipCode !== void 0 ? zipCode : undefined
        };
    }
    return undefined;
};

export { mapManufacturerToClient };
//# sourceMappingURL=map-to-manufacturer.js.map
